const SUPER_ADMIN_PATH = '/super-admin/'
const ASSESSMENT_DESIGNER_PATH = '/hospital/form-assessment'
const LAB_ORDER_FORM_DESIGNER_PATH = '/hospital/lab-order-form-designer'

const normalizeMenuChildren = (items = []) => {
  if (Array.isArray(items)) return items
  if (items && typeof items === 'object') return Object.values(items)
  return []
}

const normalizeMenuPath = (url = '') =>
  String(url).split('?')[0].replace(/\/$/, '')

const isAssessmentDesignerMenu = (item) => {
  const path = normalizeMenuPath(item?.url)
  return (
    path.startsWith(SUPER_ADMIN_PATH) &&
    path.endsWith(ASSESSMENT_DESIGNER_PATH)
  )
}

const containsLabOrderFormDesignerMenu = (items = []) =>
  normalizeMenuChildren(items).some((item) => {
    const path = normalizeMenuPath(item?.url)
    return (
      path.endsWith(LAB_ORDER_FORM_DESIGNER_PATH) ||
      containsLabOrderFormDesignerMenu(item?.children)
    )
  })

export const addLabOrderFormDesignerMenu = (items = []) => {
  if (
    !Array.isArray(items) ||
    containsLabOrderFormDesignerMenu(items)
  ) {
    return items
  }

  let inserted = false
  const addAfterAssessmentDesigner = (menuItems = []) =>
    normalizeMenuChildren(menuItems).reduce((result, item) => {
      if (!item) return result

      const nextItem = item.children
        ? { ...item, children: addAfterAssessmentDesigner(item.children) }
        : item
      result.push(nextItem)

      if (!inserted && isAssessmentDesignerMenu(item)) {
        const assessmentPath = normalizeMenuPath(item.url)
        result.push({
          access: item.access || [],
          color: item.color,
          groupMenuId: item.groupMenuId,
          icon: item.icon,
          iconColor: item.iconColor,
          iconSource: item.iconSource,
          iconText: item.iconText,
          iconTextColor: item.iconTextColor,
          iconType: item.iconType,
          id: `${item.groupMenuId || 'admin-panel'}-lab-order-form-designer`,
          linkType: 'router',
          seq: Number(item.seq || 0) + 0.01,
          title: 'Lab Order Form Designer',
          type: 'item',
          url: assessmentPath.replace(
            ASSESSMENT_DESIGNER_PATH,
            LAB_ORDER_FORM_DESIGNER_PATH,
          ),
        })
        inserted = true
      }

      return result
    }, [])

  return addAfterAssessmentDesigner(items)
}
